module.exports = __webpack_public_path__ + "img/physics4.661726d4.png";